// ApplicationDetails.jsx
import React from 'react';
import Step6Upd from '../../../../cabinet/wizplain/components/Step6Upd'; 

const ApplicationDetails = ({ applicationData, mode }) => {
  // Преобразуем данные заявки в формат для Step6Upd
  const formData = {
    child: {
      lastName: applicationData.childLastName,
      firstName: applicationData.childFirstName,
      middleName: applicationData.childMiddleName,
      birthDate: applicationData.birthDate,
      gender: applicationData.gender,
      birthCertificate: {
        seriesNumber: applicationData.birthCertificate,
        issueDate: applicationData.certificateIssueDate,
        country: applicationData.certificateCountry
      },
      address: applicationData.registeredAddress,
      addressFact: applicationData.actualAddress,
      sameFactAddress: applicationData.sameAddress ? "yes" : "no"
    },
    applicant: {
      lastName: applicationData.applicantLastName,
      firstName: applicationData.applicantFirstName,
      middleName: applicationData.applicantMiddleName,
      citizenship: applicationData.citizenship,
      hasRnokpp: applicationData.hasRnokpp ? "yes" : "no",
      rnokpp: applicationData.rnokpp,
      documentType: applicationData.documentType,
      documentDetails: applicationData.documentDetails,
      phone: applicationData.phone,
      email: applicationData.email,
      address: applicationData.applicantAddress
    },
    preferences: {
      desiredDate: applicationData.desiredDate,
      ageMenu: applicationData.ageMenu,
      inclusiveGroup: applicationData.inclusiveGroup,
      diseaseType: applicationData.diseaseType,
      diseaseDocument: applicationData.diseaseDocument
    },
    benefits: applicationData.benefits || {},
    selectedSchools: applicationData.selectedSchools || [],
    dictionary: {
      addresses: applicationData.addresses || {}
    },
    agreePersonalData: applicationData.agreePersonalData ? "yes" : "no"
  };

  return (
    <div className="application-details">
      <Step6Upd 
        formData={formData}
        errors={{}}
        onChange={() => {}} // Пустая функция, так как режим просмотра
        isPreview={true}
      />
    </div>
  );
};

export default ApplicationDetails;